module.exports = __webpack_public_path__ + "static/media/DSC_0868.17094e25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0868.jpg
// module id = 607
// module chunks = 0